module.exports = __webpack_public_path__ + "img/agricultura_familiar_ouro.8808d44f.png";